import moment from 'moment';

function dateDifferenceInDays(dateFrom: string, dateTo: string, wholeDays: boolean = true): number {

  if (dateFrom && dateTo) {
    const fromDate = moment(dateFrom);
    const toDate = moment(dateTo);

    let dayDifference = toDate.diff(fromDate, 'days');

    return wholeDays
      ? ++dayDifference
      : dayDifference;
  }

  return 0;
}

export {
  dateDifferenceInDays
};
